module.exports = __webpack_public_path__ + "5f83f1f4eaa09196df70aed138341f0b.jpg";